// components/Icons.jsx

export const IconMail = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M4 4h16v16H4V4zm0 0l8 8 8-8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPhone = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.11A19.5 19.5 0 0 1 4.2 8.81 19.86 19.86 0 0 1 1.09 1.82 2 2 0 0 1 3 0h3a2 2 0 0 1 2 1.72 12.19 12.19 0 0 0 .57 2.58 2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.29 6.29l1.27-1.27a2 2 0 0 1 2.11-.45 12.19 12.19 0 0 0 2.58.57A2 2 0 0 1 22 16.92z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconWhatsApp = (props) => (
  <svg viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M16 0C7.164 0 0 7.164 0 16c0 2.834.738 5.494 2.026 7.824L0 32l8.38-2.007A15.892 15.892 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333c-2.5 0-4.843-.655-6.898-1.806l-.493-.29-4.978 1.193 1.272-4.89-.32-.504A13.284 13.284 0 0 1 2.667 16C2.667 8.82 8.82 2.667 16 2.667 23.18 2.667 29.333 8.82 29.333 16c0 7.18-6.153 13.333-13.333 13.333zm7.205-9.333c-.396-.198-2.348-1.157-2.712-1.29-.364-.135-.63-.198-.895.198-.26.396-1.03 1.29-1.26 1.552-.229.26-.47.291-.866.094-.396-.198-1.671-.616-3.182-1.96-1.176-1.05-1.97-2.344-2.2-2.74-.229-.396-.024-.609.174-.807.179-.178.396-.47.593-.706.198-.229.26-.396.396-.656.135-.26.073-.49-.037-.687-.114-.197-.895-2.16-1.228-2.952-.323-.781-.653-.676-.895-.687l-.761-.015c-.26 0-.677.094-1.03.49-.353.396-1.353 1.32-1.353 3.217 0 1.896 1.384 3.73 1.577 3.99.198.26 2.729 4.168 6.606 5.848 3.877 1.68 3.877 1.12 4.575 1.05.698-.07 2.348-.958 2.68-1.883.323-.925.323-1.717.229-1.883-.093-.167-.353-.26-.75-.458z"
      fill="currentColor"
    />
  </svg>
);

export const IconInstagram = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const IconFacebook = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
);

export const ChevronDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);